export default "__VITE_ASSET__6c420318__"